import { useCurrentStateAndParams } from '@uirouter/react';
import { useEffect } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { ngContext } from '../../../../core/services/ng.delegate';
import { pageStateAtom } from '../groups_list_atoms';
import { pageStateVM } from '../../../../core/page/page_view_models';

export const useGroupsListInit = (): void => {
    const route = useCurrentStateAndParams();
    const setState = useSetImmerAtom(pageStateAtom);

    // INIT
    useEffect(() => {
        setState(draft => {
            if (draft.init) {
                // get context from Angular
                const ctx = ngContext();
                draft.canEdit = !!ctx && !!ctx.User;
                draft.init = false;
                return draft;
            } else {
                return draft;
            }
        });

        // destroy
        return (): void => {
            setState(() => pageStateVM());
        };
    }, [route, setState]);
};
